import useSWRImmutable from 'swr/immutable';

import { AISuggestion } from 'models';

import { useCurrentUser } from 'hooks/use-current-user';
import { AIService } from 'services/AIService';

const useAISuggestions = () => {
    const user = useCurrentUser();

    const { data } = useSWRImmutable(`aiSuggestions`, async () => {
        if (!user) {
            return [];
        }

        return await AIService.getAiSuggestions();
    });

    return (data?.docs ?? []) as AISuggestion[];
};

export { useAISuggestions };
